/* tslint:disable */
/* eslint-disable */
export enum NoteEntityClass {
  Form = 'Form',
  FormQualitySection = 'FormQualitySection',
}
